<template>
  <div>
    <template v-if="isBot">
      <BotContent :colors="colors">
        <BotInnerHeader
          :colors="colors"
          :title="headerTitle"
          :sub-title="headerSubTitle"
          :back-route="headerBackRoute"
          :show-back="headerShowBack"
        />

        <slot />
      </BotContent>
    </template>

    <template v-else-if="isWidget || isFacebook">
      <div>
        <BContainer v-if="$site.settings.notice.enabled && layoutStore.notice" class="mb-8">
          <BAlert :icon="false">
            <span v-html="formatHtml($site.settings.notice.content)" />
          </BAlert>
        </BContainer>

        <BContainer v-if="breadcrumbs" class="mb-8">
          <b-breadcrumbs :breadcrumbs="breadcrumbs" />
        </BContainer>

        <slot />
      </div>
    </template>

    <template v-else>
      <div class="py-6 sm:py-12">
        <BContainer v-if="!isApp && $site.settings.notice.enabled && notice" class="mb-8">
          <BAlert :icon="false">
            <span v-html="formatHtml($site.settings.notice.content)" />
          </BAlert>
        </BContainer>

        <BContainer class="mb-8">
          <b-page-title :title="headerTitle" :sub-title="headerSubTitle" :loading="loading" :alert="alert" />
        </BContainer>

        <BContainer v-if="breadcrumbs" class="mb-8">
          <b-breadcrumbs :breadcrumbs="breadcrumbs" />
        </BContainer>

        <div id="content">
          <slot />
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
export default {
  name: 'BLayout'
}
</script>

<script setup lang="ts">
import Utils from '@/utils'

const layoutStore = useLayoutStore()

const props = defineProps({
  colors: {
    type: Object,
    required: true
  },
  headerTitle: {
    type: String,
    default: ''
  },
  headerSubTitle: {
    type: String,
    default: ''
  },
  headerShowBack: {
    type: Boolean,
    default: true
  },
  headerBackRoute: {
    type: Object,
    default: null
  },
  breadcrumbs: {
    type: Array,
    default: null
  },
  loading: {
    type: Boolean,
    default: false
  },
  alert: {
    type: [String, Number],
    default: null
  },
  notice: {
    type: Boolean,
    default: true
  }
})

const layout = computed(() => {
  return layoutStore.layout
})

const isBot = computed(() => {
  return layout.value === 'bot'
})

const isWidget = computed(() => {
  return layout.value === 'widget'
})

const isFacebook = computed(() => {
  return layout.value === 'facebook'
})

const isApp = computed(() => {
  return layout.value === 'app'
})

const formatHtml = (text: string) => {
  return Utils.text.formatHtml(text)
}
</script>
